import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import styles from "./Placeholder.module.css";

export default function NotFound() {
  return (
    <div className={styles.page}>
      <h1>404</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/" className={styles.homeBtn}>
        <ArrowLeft size={14} />
        Back to Home
      </Link>
    </div>
  );
}
